import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { combineLatest, map, tap } from 'rxjs';
import { SessionService } from '@services/session.service';
import { AccessLevel } from '../types/configuration';
import { filterNullish } from '@shared/helpers/helpers';

export const AccessLevelGuard = (): CanActivateFn => () => {
  const router: Router = inject(Router);
  const sessionService: SessionService = inject(SessionService);
  return combineLatest([sessionService.accessLevel$]).pipe(
    map(([accessLevel]: [AccessLevel | undefined]) => accessLevel),
    tap((accessLevel) => console.log('Access Level pre-tap:', accessLevel)),
    filterNullish,
    tap((accessLevel) => console.log('Access Level post-tap:', accessLevel)),
    map((accessLevel: AccessLevel) => {
      try {
        return ['ADMIN', 'TEST'].includes(accessLevel) || router.createUrlTree(['unauthorized']);
      } catch (e) {
        console.error(e);
        return router.createUrlTree(['unauthorized']);
      }
    }),
  );
};
